import axios from 'axios'
// token过期弹窗次数
let count = 0
const host = process.env.NODE_ENV === 'production' ? '' : ''

const service = axios.create({
  baseURL: host, // api 的 base_url
  withCredentials: true, // 跨域请求时发送 cookies
  timeout: 80000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        if(localStorage.getItem('token') != null){
          config.headers["Authentication"] = localStorage.getItem('token')
        }else{
          config.headers["Authentication"] = localStorage.getItem('Authentication')
        }

        return config
      },
      error => {
        return Promise.reject(error)
      }
    )

    service.interceptors.response.use(
      response => {
        const res = response
        // 视频回放接口不处理直接返回
        if (res.config.url.indexOf('get_sim_info') == -1) {
          if (res.data.hasOwnProperty('status') && !res.data.status) {
            const msg = locale !== 'zh' ? res.data.msg_en : res.data.msg
            if (res.data.msg == 'token验证失败，请重新登录！' || res.data.msg == 'session验证失败，请重新登录！') {
              // 只提示一次token过期
              if (!count) {
                count = 1
              }
              setTimeout(() => {
                localStorage.clear()
                location.reload()
              }, 1 * 1000)
            }
          }
        }
        return res
      },
      error => {
        console.log('err' + error) // for debug
        let netWork = ''
        if (!navigator.onLine) {
          netWork = '无网络'
        }
        return {
          msg: netWork || error.msg || '网络异常!',
          data: {
            msg: netWork || error.msg || '网络异常!'
          },
          status: false,
          code: 1
        }
      }
    )

    export default service
